export const fetchStatus = {
  idle: "idle",
  fetching: "fetching",
  success: "success",
  error: "error",
} as const;

type FetchStatusType = (typeof fetchStatus)[keyof typeof fetchStatus];

/**
 * Обертка для запросов стора
 */
export function withRequestTracking<T>(
  context: { loading: boolean; fetchStatus: FetchStatusType; fetchError?: unknown },
  fn: () => Promise<T>
): Promise<T | undefined> {
  return (async () => {
    context.loading = true;
    context.fetchStatus = fetchStatus.fetching;
    context.fetchError = undefined;

    try {
      const result = await fn();
      context.fetchStatus = fetchStatus.success;
      return result;
    } catch (error) {
      context.fetchStatus = fetchStatus.error;
      context.fetchError = error;
      throw error;
    } finally {
      context.loading = false;
    }
  })();
}
